export default "__VITE_ASSET__61WXvdlm__"